import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import Input from '@/components/General/inputs/Input';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { saveBatch } from '@/data/contributions';
import ModalWrapper from '@/components/General/ModalWrapper';
import Toast from 'react-native-toast-message';
import { Query } from '@/utils/react-query/Queries';
import { QueryKeys } from '@/utils/react-query/QueryKeys';
import { useRouter, useLocalSearchParams } from 'expo-router';

const AddContributionBatchModal = () => {
  const [batchDetails, setBatchDetails] = useState('');
  const { id } = useLocalSearchParams()

  const router = useRouter()

  /*** Queries ***/
  const queryClient = useQueryClient()
  const { data: batchToEdit } = Query.contributionBatches.byId({id: id, options: {enabled: !!id}})

  useEffect(() => {
    if(batchToEdit && id){
        setBatchDetails({name: batchToEdit.name, id: batchToEdit.id, originalValues: batchToEdit})
    }
  }, [batchToEdit, id])

  const saveBatchMutation = useMutation({
    mutationFn: saveBatch,
    onSuccess: () => {
        queryClient.invalidateQueries({queryKey: QueryKeys.contributionBatches.byId(id)});
        queryClient.invalidateQueries({queryKey: QueryKeys.contributionBatches.latest()});
        queryClient.invalidateQueries({queryKey: QueryKeys.contributionBatches.all()});
        router.push({pathname: "contributions", params: {latest: "1"}});
        setTimeout(() => Toast.show({ type: 'success', text2: `Batch ${id ? "updated" : "created"} successfully!` }), 100);
    },
    onError: () => {
        setTimeout(() => Toast.show({ type: 'error', text2: `Failed to ${id ? "update" : "create"} batch!` }), 100);
    },
  });

  return (
    <ModalWrapper 
        title={id ? "Edit Batch" : "New Batch"} 
        loading={saveBatchMutation.isPending}
        onConfirm={() => {
            const { originalValues, ...clean } = batchDetails;
            saveBatchMutation.mutate({name: clean?.name, id: clean?.id, originalValues})
        }} 
        confirmText={id ? "Update" : "Create"}
    >
        <View style={{padding:10}}>
            <Input
                title="Batch Name (optional)"
                value={batchDetails?.name}
                onUpdate={(new_value) => {
                    setBatchDetails({
                        ...batchDetails,
                        name: new_value
                    })
                }}
                placeholder="Enter a descriptive name for the batch"
            />
        </View>
    </ModalWrapper>
  );
};

export default AddContributionBatchModal;
